import React from "react";
import _ from "underscore";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";
import Slider from "react-slick";
import { carouselSettings } from "../common/utils";
import { getDiscoverCollection, getResponsiveSettings } from "./helpers";
import DiscoverProductVariation from "./DiscoverProductVariation";
import LpNewNextArrow from "../common/LpNewNextArrow";
import LpNewPrevArrow from "../common/LpNewPrevArrow";
import Button from "react-bootstrap/Button";
import config from "../../config";

const DiscoverCollections = () => {
    const responsive_settings = getResponsiveSettings();
    const slider_settings = {
        className: "discover-carousel__cards",
        dotsClass: "slick-dots--custom",
        arrows: window.innerWidth > 768,
        dots: window.innerWidth > 768,
        slidesToShow: window.innerWidth <= 768 ? 1.5 : 4,
        swipeToSlide: window.innerWidth <= 768,
        slidesToScroll: window.innerWidth <= 768 ? 1 : 4,
        nextArrow: <LpNewNextArrow
            customClass="slick-arrow slick-next discover-arrows"
            stroke="black"
            customStyle={{width: 10}}
        />,
        prevArrow: <LpNewPrevArrow
            customClass="slick-arrow slick-prev discover-arrows"
            stroke="black"
            customStyle={{width: 10}}
        />,
        responsive: responsive_settings,
    }
    const sliderSettings = carouselSettings(slider_settings);
    const discover_collections = getDiscoverCollection();
    const item_limit = 12;

    return (
        <div className="discover-carousel">
            <Container>
                <Row>
                    <Col>
                        <h2 className="discover-carousel__title">Discover the Latest Statement-Making Styles</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Tabs
                            id="personalized-collections"
                            className="discover-carousel__tab-container"
                        >
                            {_.map(discover_collections, (discover_collection, discover_collection_filter) => {
                                if (_.isEmpty(discover_collection.products)) {
                                    return null;
                                }
                                const collection_name = discover_collection.collection;
                                const tab_title = <span>
                                    <div className="discover-carousel__tab--title">
                                        {collection_name}
                                    </div>
                                </span>;
                                return (
                                    <Tab
                                        key={discover_collection_filter}
                                        eventKey={discover_collection_filter}
                                        title={tab_title}
                                        unmountOnExit={true}
                                        tabClassName="discover-carousel__tab"
                                    >
                                        <div className="discover-carousel__cards-container">
                                            <Slider {...sliderSettings}>
                                                {_.last(_.map(discover_collection.products, (product, id) => {
                                                    return (
                                                        <DiscoverProductVariation key={id} product={product} />
                                                    )
                                                }), item_limit)}
                                            </Slider>
                                        </div>
                                        <Button
                                            className="discover-carousel__see-all-cta rbg-btn-dark"
                                            href={discover_collection.cta_url}
                                            variant="secondary"
                                        >
                                            Shop All
                                        </Button>
                                    </Tab>
                                )
                            })}
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DiscoverCollections;